import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import { 
  AssignmentInd,
  ManageAccounts
} from '@mui/icons-material';
import { 
  Layout,
  Col, 
  Row,
  Button, 
  Dropdown, 
  Space,
  Modal,
  Form,
  Select,
  Input,
  Menu, 
} from 'antd';

import { ExclamationCircleFilled } from '@ant-design/icons';

import { MoreVert  } from '@mui/icons-material';
import { UsePostRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { refreshPage } from '../../Utils/Common';
// import { getUserRole } from '../../Utils/Common';

const { Item } = Form;
const { Option } = Select;
const { Search } = Input;
const { confirm } = Modal;

const Users = () => {
  // const user_role = getUserRole()
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [userDetails, setUserDetails] = useState({
    email: '',
    name:'',
    role:'',
    member_id: ''
  });
  const [filterConfig, setFilterConfig] = useState({
    // user_id: '',
    term: '',
  })
  const [roleOptions, setRoleOptions] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);
  const staffRoleOptions = roleOptions.filter(role => role.value !== '4');
  const [userData, setUserData] = useState([])
  const [memberData, setMemberData] = useState([])
  const [memberName, setMemberName] = useState([])
  const [memberStatus, setMemberStatus] = useState('1')
  const [current, setCurrent] = useState('staff');
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [resetForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
  //   fetchTableData()
    refreshPage()
    form.resetFields();
    editForm.resetFields();
    setAddVisible(false); 
    setEditVisible(false);
    setResetVisible(false);
    fetchTableData()
    setMemberName([])
  });

  const handleMenu = (e) => {
    setCurrent(e.key);
  };

  const items = [
    {
      label: 'Staff',
      key: 'staff',
      icon: <ManageAccounts />,
    },
    {
      label: 'Member',
      key: 'member',
      icon: <AssignmentInd />,
    },
  ];

  function ActionBtn(row) {
    const items = [
      {
        key: '1',
        label: (
        <div onClick={() => showResetModal(row.row.id, row.row)}>
            Reset Password
        </div>
        ),
      },
      {
        key: '2',
        label: (
          <div onClick={()=>showEditModal(row.row.id, row.row)}>
              Edit
          </div>
        ),
      },
      {
        key: '3',
        label: (
          <div onClick={()=>showDeleteConfirm(row.row.id)} className='red'>
              Delete
          </div>
        ),
      },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  async function fetchTableData() {
    setIsLoading(true);
    const response = await UsePostRequest("users/get", filterConfig);
    if (response.data) {
      setUserData(response?.data);
    } else {
      setUserData([])
    }
    setIsLoading(false);
  }
  
  async function fetchMemberNoAccount() {
    const response = await UsePostRequest("members/get_member_no_account", {account_status: memberStatus});
    if (response?.response) {
      setMemberData(response?.response?.members);
    } else {
      setMemberData([])
    }
  }

  const showAddModal = () => {
    setAddVisible(true);
    setMemberStatus(1)
  };

  const showEditModal = (id, user_details) => {
    setUserId(id) 
    setMemberStatus(0)
    setUserDetails(() => ({
      email: user_details.email,
      name: user_details.name,
      role: String(user_details.role_id),
      member_id: user_details.member_id,
    }));     
    editForm.setFieldsValue({
      email: user_details.email,
      name: user_details.name,
      role: String(user_details.role_id),
      member_id: user_details.member_id,
    });
    setEditVisible(true);
  };

  const showResetModal = (id, user_details) => {
    setUserId(id)
    setUserDetails(() => ({
      email: user_details.email,
      name: user_details.name,
      role: String(user_details.role_id),
    }));     
    resetForm.setFieldsValue({
      email: user_details.email,
      name: user_details.name,
      role: String(user_details.role_id),
    });
    setResetVisible(true);
  };

  const handleAddCancel = () => {
    form.resetFields();
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditVisible(false);
  };

  const handleResetCancel = () => {
    resetForm.resetFields();
    setResetVisible(false);
  };

  const handleAddOk = () => {
    form.validateFields().then(values => {
      const data = {
        role_id: current === "staff" ? values.role : '4',
        name: values.name ? values.name : memberName.member_name,
        member_id: values.member_id,
        email: values.email,
        password: values.password,
        confirm_password: values.confirm_password,
      }
      callPost(
        "users/add", 
        data,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleEditOk = () => {
    editForm.validateFields().then(values => {
      const resetData = {
        role_id: values.role,
        name: values.name ? values.name : memberName.member_name,
        member_id: values.member_id,
        email: values.email,
        user_id: userId
      }
      callPost(
        "users/update", 
        resetData,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed Edit:', errorInfo);
    });
  };

  const handleResetOk = () => {
    resetForm.validateFields().then(values => {
      const resetData = {
        password: values.password,
        confirm_password: values.confirm_password,
        user_id: userId
      }
      callPost(
        "users/update", 
        resetData,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure delete this User?',
      icon: <ExclamationCircleFilled/>,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "users/delete", 
          {user_id: id},
          false
        );
      },
    });
  };

  const passwordValidator = (rule, value, callback) => {
    const password = form.getFieldValue('password');
    if (value && password && value !== password) {
      callback('Passwords do not match!');
    } else {
      callback();
    }
  };

  const passwordEditValidator = (rule, value, callback) => {
    const password = resetForm.getFieldValue('password');
    if (value && password && value !== password) {
      callback('Passwords do not match!');
    } else {
      callback();
    }
  };

  const handleChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        term: e || '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          term: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  console.log(memberName)

  const handleMemberId = (e) => {
    if(e){
      const member_data = memberData.filter(item => item.id === e)
      setMemberName(member_data[0])
    }
  };

  useEffect(() => {
    let active = true;
    async function fetchRoles() {
      const response = await UsePostRequest('roles/get', {});
      if (!active) return;
      const roles = response?.data;
      if (Array.isArray(roles)) {
        setRoleOptions(roles.map(role => ({
          value: String(role.id),
          label: role.name.replace(/_/g, ' '),
        })));
      } else {
        toast.error('Unable to load roles. Please reload the page to try again.');
      }
      setRolesLoading(false);
    }
    fetchRoles();
    return () => { active = false; };
  }, []);

  useEffect(() => {
    fetchTableData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  useEffect(() => {
    fetchMemberNoAccount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberStatus]);

  useEffect(() => {
    if(current === "staff"){
      form.setFieldsValue({ role: '' });
    } else {
      form.setFieldsValue({ role: 'Member' });
    }
  }, [form, current]);

  return (
    <Layout className='page'>
      <Navbar navKey={'user_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={9} className='header-container'>
            USER
          </Col>
          <Col span={15} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <Search
                placeholder="Search Member"
                size='medium'
                onSearch={(e)=>handleChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />    
      
              <Button 
                className='button-color responsive-header-btn' 
                onClick={showAddModal} 
                type="primary"
              >
                + Add User
              </Button>
            </Space>
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <AntDTable
              tableHeaders={[
                "Name",
                "Role",
              ]}
              headerSelector={[
                "name",
                "role_name",
              ]}
              tableData={userData}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={isLoading}
              isClickable={false}
              tablePages={10}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
      <Modal
        title="Add User"
        confirmLoading={loading}
        open={addVisible}
        onOk={handleAddOk}
        onCancel={handleAddCancel}
        maskClosable={false}
      >
        <Menu 
          onClick={handleMenu} 
          selectedKeys={[current]} 
          mode="horizontal" 
          items={items} 
          className='mb-4'
        />
        <Form 
          form={form} 
          layout="vertical"
          initialValues={{ member_role: 'Member' }} 
        >
          {
            current === "staff" ? (
              <>
                <Item
                  label="Role"
                  name="role"
                  rules={[{ required: true, message: 'Please select your Role' }]}
                >
                  <Select placeholder="Select a Role" options={staffRoleOptions} loading={rolesLoading} disabled={rolesLoading || staffRoleOptions.length === 0} />
                </Item>
                <Item
                  label="Full Name"
                  name="name"
                  rules={[{ required: true, message: 'Please enter your full name!' }]}
                >
                  <Input />
                </Item>
              </>
            ) : (
              <>
                <Item
                  label="Role"
                  name="member_role"
                  rules={[{ required: true, message: 'Please select your Role' }]}
                >
                  <Input disabled/>
                </Item>
                <Item
                  label="Member"
                  name="member_id"
                  rules={[{ required: true, message: 'Please enter your Member!' }]}
                >
                  <Select 
                    placeholder="Select a Member (w/o account)"
                    showSearch
                    onChange={(e) => handleMemberId(e)}
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {
                      memberData?.map((data) => (
                        <Option key={data.id} value={data.id}>{data.member_name}</Option>
                      ))
                    }
                  </Select>
                </Item>
              </>
            )
          }
           <Item
              label="Email"
              name="email"
              rules={[{ required: true, message: 'Please enter your username!' }]}
            >
                <Input />
            </Item>
            <Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password!' }]}
            >
              <Input.Password />
            </Item>
            <Item
              label="Confirm Password"
              name="confirm_password"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please enter your confirm password!' },
                { validator: passwordValidator }
              ]}
            >
              <Input.Password />
            </Item>
        </Form>
      </Modal>
      <Modal
        title="Edit User"
        confirmLoading={loading}
        open={editVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        maskClosable={false}
      >
        <Form 
          form={editForm} 
          layout="vertical" 
          initialValues={userDetails}
        >
          {
            String(userDetails?.role) !== "4" ? (
              <>
                <Item
                  label="Role"
                  name="role"
                  rules={[{ required: true, message: 'Please select your Role' }]}
                >
                  <Select placeholder="Select a Role" options={staffRoleOptions} loading={rolesLoading} disabled={rolesLoading || staffRoleOptions.length === 0} />
                </Item>
                <Item
                  label="Full Name"
                  name="name"
                  rules={[{ required: true, message: 'Please enter your full name!' }]}
                >
                  <Input />
                </Item>
              </>
            ) : (
              <>
                <Item
                  label="Role"
                  name="role"
                  rules={[{ required: true, message: 'Please select your Role' }]}
                >
                  <Select placeholder="Select a Role" options={roleOptions} loading={rolesLoading} disabled />
                </Item>
                <Item
                  label="Member"
                  name="member_id"
                  rules={[{ required: true, message: 'Please enter your Member!' }]}
                >
                  <Select 
                    placeholder="Select a Member (w/o account)"
                    showSearch
                    disabled
                    onChange={(e) => handleMemberId(e)}
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {
                      memberData?.map((data) => (
                        <Option key={data.id} value={data.id}>{data.member_name}</Option>
                      ))
                    }
                  </Select>
                </Item>
              </>
            )
          }
          <Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please enter your Username!' }]}
          >
            <Input />
          </Item>
        </Form>
      </Modal>
      <Modal
        title="Reset Password"
        confirmLoading={loading}
        open={resetVisible}
        onOk={handleResetOk}
        onCancel={handleResetCancel}
        maskClosable={false}
      >
        <Form 
          form={resetForm} 
          layout="vertical"
          initialValues={userDetails}
        >
          <Item
            label="Email"
            name="email"
            initialValue={userDetails.username}
          >
            <Input 
              disabled
            />
          </Item>
          <Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your Password!' }]}
          >
            <Input.Password />
          </Item>
          <Item
            label="Confirm Password"
            name="confirm_password"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please enter your confirm password!' },
              { validator: passwordEditValidator }
            ]}                    
          >
            <Input.Password/>
          </Item>
        </Form>
      </Modal>
    </Layout>
  )
}

export default Users
